import { STORE_ITEM_TYPES } from "../storeAPI"

export enum STORE_CURRENCY {
  TG_STARS = "tg-stars",
  EXTERNAL_TON = "external-ton",
  GOLDEN_DUST = "golden-dust"
}

export interface ICreateInvoiceDto {
  itemId: string
  itemType: STORE_ITEM_TYPES
  currency: STORE_CURRENCY
  amount?: number
  totalAmount?: number
  cardId?: string
  price: number
}

export interface IStarPaymentInvoice {
  kind: STORE_CURRENCY.TG_STARS
  receiptId?: string
  invoiceLink: string
}

export interface ITonPaymentInvoice {
  kind: STORE_CURRENCY.EXTERNAL_TON
  validUntil: number
  amount: string
  to: string
  payload: string
}

export interface IGoldenDustPaymentInvoice {
  kind: STORE_CURRENCY.GOLDEN_DUST
}

export type IStorePaymentInvoice =
  | IStarPaymentInvoice
  | ITonPaymentInvoice
  | IGoldenDustPaymentInvoice
